// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import {
  CoreProductReviewFlag,
  core_apimessages_FlagProductReviewRequest_Reason as Reason,
} from '@reverbdotcom/commons/src/gql/graphql';
import { RCButton, RCRadioGroup } from '@reverbdotcom/cadence/components';
import { withPrefix } from '@reverbdotcom/commons/src/i18n_helpers';
import { SanitizedRender } from '@reverbdotcom/commons';
import URLHelpers from './shared/url_helpers';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { ProductReviewInteraction } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { useMutation } from '@reverbdotcom/commons/src/useMutation';

interface Props {
  productReviewId: string;
  cspId: string;
  onCancel: () => void;
  onFlagCreated: () => void;
}

export function ProductReviewFlagForm({
  productReviewId,
  cspId,
  onFlagCreated,
  onCancel,
}: Props) {
  const [reason, setReason] = React.useState(null);
  const [mutate, { loading }] = useMutation<
    CoreProductReviewFlag.Mutation,
    CoreProductReviewFlag.Variables
  >(
    FLAG_PRODUCT_REVIEW_MUTATION,
  );

  async function submit(e: React.ChangeEvent<HTMLFormElement>) {
    e.preventDefault();

    await mutate({
      variables: {
        input: {
          productReviewId,
          reason,
        },
      },
      refetchQueries: ['Core_Product_Reviews'],
      awaitRefetchQueries: true,
    });

    trackEvent({
      eventName: MParticleEventName.ProductReviewAction,
      productReviewInteraction: ProductReviewInteraction.FlagReview,
      productReviewId,
      cspId,
      productReviewFlagReason: reason,
    });

    onFlagCreated();
  }

  function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
    setReason(e.target.value);
  }

  return (
    <div>
      <form onSubmit={submit}>
        <div className="ptb-6 plr-4 bdb-1 bd-color-primary">
          <RCRadioGroup
            id="flag-review-reason"
            name="flag-review-reason"
            tag="required"
            label={translate('reasonsPrompt')}
            value={reason}
            onChange={handleOnChange}
          >
            <RCRadioGroup.Option label={translate('notRelevant')} value={Reason.NOT_RELEVANT} sublabel={translate('notRelevantDescription')} />
            <RCRadioGroup.Option label={translate('spam')} value={Reason.SPAM} sublabel={translate('spamDescription')} />
            <RCRadioGroup.Option label={translate('offensive')} value={Reason.OFFENSIVE}
              sublabel={
                <SanitizedRender
                  html={
                    translate(
                      'offensiveDescription',
                      { linkOpen: `<a class="text-link" href=${URLHelpers.legalPagePath('reverbcom-buyers')} target="_blank">`, linkClose: '</a>' },
                    )
                  }
                />
              }
            />
          </RCRadioGroup>
          <div className="weight-bold size-90">
            <div>{translate('description')}</div>
            <div className="mt-4">{translate('prompt')}</div>
          </div>
        </div>
        <div className="d-flex fx-justify-end pr-4 ptb-6">
          <RCButton data-flag-cancel onClick={onCancel} variant="transparent" size="medium">
            {translate('cancel')}
          </RCButton>
          <RCButton data-flag-submit isSubmit variant="filled" disabled={loading || !reason}>
            {translate('reportReview')}
          </RCButton>
        </div>
      </form>
    </div>
  );
}

const FLAG_PRODUCT_REVIEW_MUTATION = gql`
  mutation Core_ProductReview_Flag(
    $input: Input_core_apimessages_FlagProductReviewRequest
  ) {
    flagProductReview(input: $input) {
      id
    }
  }
`;

const translate = withPrefix('discovery.productReviews.flagReview.form');
